// extracted by mini-css-extract-plugin
module.exports = {"Cardcarousel":"Cardcarousel_Cardcarousel__3Dtcr","btnn":"Cardcarousel_btnn__1cDo6"};